import { useMediaQuery } from "@mui/material";
import Box from "@mui/material/Box";
import FullScreenLoader from "@/components/Layout/FullScreenLoader";
import { Suspense } from "react";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import { Outlet, useLocation } from "react-router-dom";
import norma from "../../assets/norma-wsp.webp";
import { useAppSelector } from "../../redux/store";
import Footer from "./Footer";
import Header from "./Header";

const Layout = () => {
  const isDarkMode = useAppSelector((state) => state.theme.darkTheme);
  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down("sm"));
  const location = useLocation();

  return (
    <>
      <Header />
      <Box component="main">
        <Suspense fallback={<FullScreenLoader />}>
          <Outlet />
        </Suspense>
      </Box>
      {isMobile ? (
        location.pathname !== "/carrito" &&
        location.pathname !== "/perfil/informes" &&
        location.pathname !== "/perfil/filtrarInformes" && (
          <FloatingWhatsApp
            phoneNumber="+5491163762166"
            accountName="PyM Gestiones"
            statusMessage="Tiempo de respuesta 1hr"
            chatMessage="Hola! En que podemos ayudarte?"
            darkMode={isDarkMode}
            placeholder="Escriba su consulta..."
            allowClickAway={true}
            avatar={norma}
          />
        )
      ) : (
        <FloatingWhatsApp
          phoneNumber="+5491163762166"
          accountName="PyM Gestiones"
          statusMessage="Tiempo de respuesta 1hr"
          chatMessage="Hola! En que podemos ayudarte?"
          darkMode={isDarkMode}
          placeholder="Escriba su consulta..."
          allowClickAway={true}
          avatar={norma}
        />
      )}
      <Footer />
    </>
  );
};

export default Layout;